import * as d3 from 'd3-selection'
import select from './lib/index.js'

export default function (nodes, opts) {
  opts = opts || {}

  if (!(nodes instanceof NodeList || Array.isArray(nodes))) {
    nodes = [nodes]
  }

  return d3.selectAll(nodes)
           .call(select, opts)
}
